import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { ArticleResponse } from './types';

type PublishArticleProps = {
  artistId: string;
  articleId: string;
};

export async function publishArticle({ artistId, articleId }: PublishArticleProps) {
  if (!artistId) throw Error('Artist ID is required');
  if (!articleId) throw Error('Article ID is required');

  const url = `/web/studio/artists/${artistId}/articles/${articleId}/publish`;
  const response = await api.executePostRequest<ObjectResponse<ArticleResponse>>(url);

  return response.data;
}
